import { types } from "mobx-state-tree";
import { translationService } from "../translation/TranslationService";

 const MainInfoStorageModel = types.model("MainInfoStorageModel", {
  mainInformation: types.optional(types.array(types.model({
    key: types.string,
    value : types.string,
  })), []),
}).views((self) => ({
  get rows(){
    const rows = [];
    for (let i = 0; i < self.mainInformation.length; i+= 2) {
      rows.push({
        id: i/2,
        column1: `${self.mainInformation[i].key} : ${self.mainInformation[i].value}`,
        column2: self.mainInformation[i + 1] ? `${self.mainInformation[i + 1].key} : ${self.mainInformation[i + 1].value}` : '',
      })
    }
    return rows;
  },
  get columns() {
    return [
      { field: 'column1', headerName: translationService.translate("ocrService.mainInfo.parameters"), flex: 1, sortable: false, disableColumnMenu: true },
      { field: 'column2', headerName: translationService.translate("ocrService.mainInfo.details"), flex: 1, sortable: false, disableColumnMenu: true },
    ];
  }
}))
.actions((self) => ({
  setMainInformation(data: { key: string; value: string }[]) {
    self.mainInformation.replace(data);
  },
  reset() {
    self.mainInformation.clear();
  }
}))

export const mainInfoStorage = MainInfoStorageModel.create({
  mainInformation: []
});